"use strict";
var airline_view_model_1 = require("./airline-view.model");
var base_1 = require("@bhtp-client-api/base");
var edit_1 = require("@bhtp-client-api/edit");
var validators_1 = require("./../validators");
var moment = require("moment");
var FlightViewModel = (function () {
    function FlightViewModel() {
        this.airline = new airline_view_model_1.AirlineViewModel();
    }
    FlightViewModel.shouldCollectFlights = function (flightRequirementType) {
        return Boolean(flightRequirementType && this.collectFlightRequirementTypes.find(function (type) { return type.toLowerCase() === flightRequirementType.toLowerCase(); }));
    };
    FlightViewModel.shouldValidateFlights = function (flightRequirementType) {
        return Boolean(flightRequirementType && this.validateFlightsRequirementTypes.find(function (type) { return type.toLowerCase() === flightRequirementType.toLowerCase(); }));
    };
    FlightViewModel.areFlightsRequired = function (flightRequirementType) {
        // same logic as shoultValidateFlights, but may be different in the future
        return this.shouldValidateFlights(flightRequirementType);
    };
    FlightViewModel.isEmpty = function (flight) {
        if (flight) {
            if (flight.airline) {
                return !Boolean(flight.airline.name || flight.airline.providerCode || flight.flightDate || flight.flightNumber);
            }
            else {
                return !Boolean(flight.airline || flight.flightDate || flight.flightNumber);
            }
        }
        return true;
    };
    FlightViewModel.toApiFlights = function (sources) {
        var targets = new Array();
        if (sources) {
            for (var i = 0; i <= sources.length - 1; i++) {
                targets.push(FlightViewModel.toApiFlight(sources[i], i));
            }
        }
        return targets;
    };
    FlightViewModel.toApiFlight = function (flight, correlationId) {
        var apiFlight = new base_1.ApiFlight();
        apiFlight.departureDate = moment(flight.flightDate).isValid() ? flight.flightDate : null;
        apiFlight.departureAirportCode = flight.departureAirport;
        apiFlight.arrivalAirportCode = flight.arrivalAirport;
        apiFlight.airlineCode = flight.airline ? flight.airline.providerCode : null;
        apiFlight.airlineName = flight.airline ? flight.airline.name : null;
        apiFlight.flightNumber = flight.flightNumber;
        apiFlight.doNotVerify = flight.doNotVerify;
        apiFlight.correlationId = "" + correlationId;
        // explicitly set do not verify to false as null/undefined will blow up
        if (!apiFlight.doNotVerify) {
            apiFlight.doNotVerify = false;
        }
        return apiFlight;
    };
    FlightViewModel.toApiEditFlights = function (sources, includeEmptyFlights) {
        if (includeEmptyFlights === void 0) { includeEmptyFlights = true; }
        var targets = new Array();
        if (sources) {
            for (var i = 0; i <= sources.length - 1; i++) {
                var isFlightEmpty = this.isEmpty(sources[i]);
                if (!isFlightEmpty || isFlightEmpty && includeEmptyFlights) {
                    targets.push(this.toApiEditFlight(sources[i]));
                }
            }
        }
        return targets;
    };
    FlightViewModel.toApiEditFlight = function (flight) {
        var apiFlight = new edit_1.ApiEditFlight();
        apiFlight.departureDate = moment(flight.flightDate).isValid() ? flight.flightDate : null;
        apiFlight.departureAirportCode = flight.departureAirport;
        apiFlight.arrivalAirportCode = flight.arrivalAirport;
        apiFlight.airlineCode = flight.airline ? flight.airline.providerCode : null;
        apiFlight.airlineName = flight.airline ? flight.airline.name : null;
        apiFlight.flightNumber = flight.flightNumber;
        apiFlight.doNotVerify = flight.doNotVerify;
        apiFlight.correlationId = flight.correlationId;
        // explicitly set do not verify to false as null/undefined will blow up
        if (!apiFlight.doNotVerify) {
            apiFlight.doNotVerify = false;
        }
        return apiFlight;
    };
    FlightViewModel.fromApiFlights = function (flights) {
        var convertedFlights = new Array();
        for (var i = 0; i <= flights.length - 1; i++) {
            convertedFlights.push((FlightViewModel.fromApiFlight(flights[i])));
        }
        return convertedFlights;
    };
    FlightViewModel.fromApiFlight = function (flight) {
        var convertedFlight = new FlightViewModel();
        convertedFlight.acknowledgements = flight.acknowledgements;
        convertedFlight.departureAirport = flight.departureAirportCode;
        convertedFlight.arrivalAirport = flight.arrivalAirportCode;
        convertedFlight.airline = new airline_view_model_1.AirlineViewModel();
        convertedFlight.airline.providerCode = flight.airlineCode;
        convertedFlight.airline.name = flight.airlineName || flight.airline;
        convertedFlight.flightNumber = flight.flightNumber;
        convertedFlight.doNotVerify = flight.doNotVerify;
        convertedFlight.flightDate = moment(flight.departureDate).isValid() ? flight.departureDate : null;
        return convertedFlight;
    };
    FlightViewModel.fromApiEditFlights = function (flights) {
        var convertedEditFlights = new Array();
        for (var i = 0; i <= flights.length - 1; i++) {
            convertedEditFlights.push((FlightViewModel.fromApiEditFlight(flights[i])));
        }
        return convertedEditFlights;
    };
    FlightViewModel.fromApiEditFlight = function (flight) {
        var convertedEditflight = new FlightViewModel();
        convertedEditflight.acknowledgements = flight.acknowledgements;
        convertedEditflight.departureAirport = flight.departureAirportCode;
        convertedEditflight.arrivalAirport = flight.arrivalAirportCode;
        convertedEditflight.airline = new airline_view_model_1.AirlineViewModel();
        convertedEditflight.airline.providerCode = flight.airlineCode;
        convertedEditflight.airline.name = flight.airlineName;
        convertedEditflight.flightNumber = flight.flightNumber;
        convertedEditflight.correlationId = flight.correlationId;
        convertedEditflight.doNotVerify = flight.doNotVerify;
        convertedEditflight.flightDate = null;
        // The api returns full flight date time with offset for flights, because we only need the date for
        // the date picker and we don't want moment to do any conversions we are going to create a moment
        // object that contains the date local only to the date itself.
        var flightDate = moment(flight.departureDate).utcOffset(flight.departureDate);
        if (flightDate.isValid()) {
            convertedEditflight.flightDate = flightDate.format('YYYY-MM-DD');
        }
        return convertedEditflight;
    };
    FlightViewModel.convertFlightDate = function (isoDateTimeString) {
        var indexOfSpace = isoDateTimeString.indexOf(' ');
        var isoDateString = isoDateTimeString && isoDateTimeString.length >= indexOfSpace ? isoDateTimeString.substring(0, indexOfSpace) : isoDateTimeString;
        return moment(isoDateString, 'MM/DD/YYYY').format('YYYY-MM-DD');
    };
    FlightViewModel.getFlightsValidationStatus = function (forms, flightRequirementType) {
        if (FlightViewModel.shouldValidateFlights(flightRequirementType)) {
            // if flights should be validated (eligibility should be checked on the entire trip),
            // run trip eligibility check if the form is valid.
            return forms.valid ? validators_1.FlightValidationStatus.Valid_VerifyTripEligibility : validators_1.FlightValidationStatus.Invalid;
        }
        else {
            // non-empty flights must be validated.
            for (var i = 0; i < forms.controls.length; i++) {
                var flightForm = forms.controls[i];
                if (!this.isEmpty(flightForm.getRawValue()) && !flightForm.valid) {
                    // found a flight that is neither empty nor valid.
                    // do not let the user proceed.
                    return validators_1.FlightValidationStatus.Invalid;
                }
            }
            // all flights are either empty or valid. allow the user to continue.
            return validators_1.FlightValidationStatus.Valid_SkipTripEligibility;
        }
    };
    return FlightViewModel;
}());
FlightViewModel.collectFlightRequirementTypes = [base_1.FlightRequirementTypes.optional, base_1.FlightRequirementTypes.conditional, base_1.FlightRequirementTypes.required];
FlightViewModel.validateFlightsRequirementTypes = [base_1.FlightRequirementTypes.conditional, base_1.FlightRequirementTypes.required];
exports.FlightViewModel = FlightViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/flights-view.model.js